<template>
    <div
        id="loading"
        :style="{display:showloading?'block':'none'}"
    >
        <img src="../assets/img/loading.png">
    </div>
</template>

<script>
export default {
    props: ["showloading"]
};
</script>

<style lang='scss' scoped>
#loading {
    height: 100%;
    z-index: 100;
    width: 100%;
    position: fixed;
    left: 0;
    background: #eff0f6;
    z-index: 9999999;
    top: 0;
    img {
        position: fixed;
        z-index: 9999999;
        display: block;
        left: 50%;
        top: 50%;
        margin-left: -0.2rem;
        margin-top: -0.2rem;
        width: 0.4rem;
        height: 0.4rem;
        animation: rotate 1s linear infinite;
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
